import { VISITOR_LANGUAGE_CODES } from "./languages";

function withLanguageFallbacks(entries) {
    const result = {};

    for (const [key, values] of Object.entries(entries)) {
        result[key] = { ...values };
        const fallback = values.fa || values.en || Object.values(values)[0] || "";

        for (const code of VISITOR_LANGUAGE_CODES) {
            if (!result[key][code]) {
                result[key][code] = fallback;
            }
        }
    }

    return result;
}

const baseTranslation = {
    login: {
        en: "login",
        fa: "ورود",
    },
    Store_Comments: {
        en: "Comments",
        fa: "نظرات",
    },
    Store_Register: {
        en: "Register a comment",
        fa: "ثبت نظر",
    },
    Store_wallet: {
        en: "wallet",
        fa: "کیف پول",
    },
    Store_Total: {
        en: "Total orders",
        fa: "کل سفارشات",
    },
    Store_Creditor: {
        en: "Creditor of the company",
        fa: "طلبکار از شرکت",
    },
    Store_Indebted: {
        en: "Indebted to the company",
        fa: "بدهکار به شرکت",
    },
    Store_Map: {
        en: "Map",
        fa: "نقشه",
    },
    Store_Routing: {
        en: "Routing",
        fa: "مسیریابی",
    },
    Products_Unit: {
        en: "Unit price",
        fa: "قیمت واحد",
    },
    Products_Store: {
        en: "Store price",
        fa: "قیمت فروشگاه",
    },
    Products_consumer: {
        en: "consumer price",
        fa: "قیمت مصرف کننده",
    },
    Products_customer_profit: {
        en: "Customer profit",
        fa: "سود مشتری",
    },
    Products_Quantity: {
        en: "Quantity per unit",
        fa: "تعداد در واحد",
    },
    Products_inventory: {
        en: "inventory",
        fa: "موجودی",
    },
    Products_complimentary: {
        en: "complimentary",
        fa: "اشانتیون",
    },
    Products_filter: {
        en: "filter",
        fa: "فیلتر",
    },
    Products_available: {
        en: "Only available items",
        fa: "فقط کالا های موجود",
    },
    Products_Select: {
        en: "Select category",
        fa: "انتخاب دسته بندی",
    },
    Products_Subcategory: {
        en: "Select subcategory",
        fa: "انتخاب زیر دسته",
    },
    Products_Warehouse: {
        en: "Select warehouse",
        fa: "انتخاب انبار",
    },
    Products_Brand: {
        en: "Brand selection",
        fa: "انتخاب برند",
    },
    Products_Internal: {
        en: "Internal category selection",
        fa: "انتخاب دسته بندی داخلی",
    },
    Products_Add: {
        en: "Add to cart",
        fa: "افزودن به سبد خرید",
    },
    Products_Description: {
        en: "Description",
        fa: "توضیحات",
    },
    Products_number: {
        en: "The number of orders exceeds the limit",
        fa: "تعداد سفارشات بیش از حد مجاز",
    },
    Products_Successfully: {
        en: "Successfully added to cart",
        fa: "با موفقیت به سبد خرید اضافه شد",
    },
    Preview_of_goods_Preview: {
        en: "Preview of goods",
        fa: "پیش نمایش کالا ها",
    },
    New_orders_New: {
        en: "New orders",
        fa: "سفارشات جدید",
    },
    New_orders_total: {
        en: "total",
        fa: "جمع کل",
    },
    New_orders_description: {
        en: "Record description",
        fa: "ثبت توضیحات",
    },
    New_orders_Custom: {
        en: "Custom discount",
        fa: "تخفیف سفارشی",
    },
    New_orders_product_discount: {
        en: "Product discount amount",
        fa: "مبلغ تخفیف",
    },
    New_orders_gift_amount: {
        en: "Gift amount",
        fa: "مبلغ اشانتیون",
    },
    New_orders_manual_discount: {
        en: "Manual discount",
        fa: "تخفیف دستی",
    },
    New_orders_warehouse_rent: {
        en: "Warehouse rent",
        fa: "کرایه انبار",
    },
    New_orders_previous_account: {
        en: "Previous account",
        fa: "حساب قبلی",
    },
    New_orders_account: {
        en: "Payable amount with previous account",
        fa: "مبلغ قابل پرداخت با حساب قبلی",
    },
    New_orders_Invoice: {
        en: "Invoice amount with discounts",
        fa: "مبلغ فاکتور با تخفیفات",
    },
    New_orders_status: {
        en: "invoice status",
        fa: "وضعیت فاکتور",
    },
    New_orders_debtor: {
        en: "the debtor",
        fa: "بدهکار",
    },
    New_orders_creditor: {
        en: "creditor",
        fa: "طلبکار",
    },
    New_orders_Cancel: {
        en: "Cancel",
        fa: "لغو",
    },
    New_orders_Edit: {
        en: "Edit",
        fa: "ویرایش",
    },
    New_orders_and: {
        en: "Edit and invoice",
        fa: "ویرایش فاکتور",
    },
    New_orders_Call: {
        en: "Call",
        fa: "تماس تلفنی",
    },
    New_orders_distributor: {
        en: "distributor",
        fa: "تحصیلدار(موضع)",
    },
    New_orders_Invoice_description: {
        en: "Invoice description",
        fa: "توضیحات فاکتور",
    },
    New_orders_Record: {
        en: "Record",
        fa: "ثبت",
    },
    Cart: {
        en: "Cart",
        fa: "سبد خرید",
    },
    Cart_Ongoing: {
        en: "Ongoing",
        fa: "در دست اقدام",
    },
    Cart_Confirmed: {
        en: "Confirmed orders",
        fa: "سفارشات تایید شده",
    },
    Cart_List: {
        en: "List of payments",
        fa: "لیست پرداختی ها",
    },
    Cart_Canceled: {
        en: "Canceled orders",
        fa: "سفارشات کنسل شده",
    },
    Cart_returns: {
        en: "returns",
        fa: "مرجوعی ها",
    },
    Ongoing_Orders: {
        en: "Orders in progress",
        fa: "سفارشات در دست اقدام",
    },
    Ongoing_first: {
        en: "first name and last name",
        fa: "نام و نام خانوادگی",
    },
    Ongoing_send: {
        en: "send to warehouse",
        fa: "ارسال به انبار",
    },
    Ongoing_customer: {
        en: "Send to customer",
        fa: "ارسال به مشتری",
    },
    Ongoing_Returned: {
        en: "Returned goods",
        fa: "کالای برگشتی",
    },
    Ongoing_payment: {
        en: "the payment",
        fa: "پرداخت",
    },
    Ongoing_Return: {
        en: "Return of the entire invoice",
        fa: "برگشت کل فاکتور",
    },
    Confirmed_orders_Accepted: {
        en: "Accepted",
        fa: "تایید شده",
    },
    Confirmed_orders_: {
        en: "returned",
        fa: "مرجوعی",
    },
    Confirmed_orders_returnedd: {
        en: "returned",
        fa: "مرجوع",
    },
    Return_orders_Return: {
        en: "Return orders",
        fa: "سفارشات مرجوعی",
    },
    Return_orders: {
        en: "returned",
        fa: "برگشتی",
    },
    List_of_payments_pos: {
        en: "pos",
        fa: "کارتخوان",
    },
    List_of_payments_cash: {
        en: "cash",
        fa: "نقدی",
    },
    List_of_payments_Czech: {
        en: "Czech",
        fa: "چک",
    },
    List_of_payments_Amount: {
        en: "Amount",
        fa: "مبلغ",
    },
    List_of_payments_Issue: {
        en: "Issue Tracking",
        fa: "شماره پیگیری",
    },
    List_of_payments_Reference: {
        en: "Reference",
        fa: "مرجع",
    },
    List_of_payments_Terminal: {
        en: "Terminal number",
        fa: "شماره پایانه",
    },
    List_of_payments_card: {
        en: "card number",
        fa: "شماره کارت",
    },
    List_of_payments_Name: {
        en: "Name of the card holder",
        fa: "نام دارنده کارت",
    },
    List_of_payments_receipt: {
        en: "payment receipt",
        fa: "رسید پرداخت",
    },
    List_of_payments_display: {
        en: "Invoice display",
        fa: "نمایش فاکتور",
    },
    List_of_payments_number: {
        en: "Czech number",
        fa: "شماره چک",
    },
    List_of_payments_Date: {
        en: "Date of receipt",
        fa: "تاریخ وصول",
    },
    List_of_payments_Pay: {
        en: "Pay to",
        fa: "در وجه",
    },
    List_of_payments_account: {
        en: "account number",
        fa: "شماره حساب",
    },
    List_of_payments_Shaba: {
        en: "Shaba number",
        fa: "شماره شبا",
    },
    List_of_payments_Bank: {
        en: "Bank name",
        fa: "نام بانک",
    },
    List_of_payments_Branch: {
        en: "Branch code",
        fa: "کد شعبه",
    },
    List_of_payments_invoice: {
        en: "invoice amount",
        fa: "مبلغ فاکتور : ",
    },
    Canceled_orders_Canceled: {
        en: "Canceled",
        fa: "کنسل شده",
    },
    Building_a_store_Customer: {
        en: "Customer inquiry",
        fa: "استعلام مشتری",
    },
    Building_a_store_Enter: {
        en: "Enter the customer's mobile phone",
        fa: "موبایل مشتری را وارد نمایید",
    },
    Building_a_store_Find: {
        en: "Find a store",
        fa: "یافتن فروشگاه",
    },
    Building_a_store_Image: {
        en: "Image",
        fa: "تصویر : اختیاری",
    },
    Building_a_store_name: {
        en: "name",
        fa: "نام",
    },
    Building_a_store_last: {
        en: "last name",
        fa: "نام خانوادگی",
    },
    Building_a_store_store: {
        en: "store's name",
        fa: "نام فروشگاه",
    },
    Building_a_store_National: {
        en: "National Code",
        fa: "کد ملی : اختیاری",
    },
    Building_a_store_State: {
        en: "State",
        fa: "استان",
    },
    Building_a_store_City: {
        en: "City",
        fa: "شهر",
    },
    Building_a_store_region: {
        en: "region",
        fa: "منطقه شهرداری",
    },
    Building_a_store_Direction: {
        en: "Direction",
        fa: "مسیر",
    },
    Building_a_store_Class: {
        en: "Class",
        fa: "صنف",
    },
    Building_a_store_Landline: {
        en: "Landline phone",
        fa: "تلفن ثابت : اختیاری",
    },
    Building_a_store_phone: {
        en: "phone number",
        fa: "شماره موبایل",
    },
    Building_a_store_Credit: {
        en: "Credit required",
        fa: "اعتبار مورد نیاز : اختیاری",
    },
    Building_a_store_Postal: {
        en: "Postal code",
        fa: "کد پستی",
    },
    Building_a_store_registration: {
        en: "Store registration",
        fa: "ثبت فروشگاه",
    },
    Settings: {
        en: "Settings",
        fa: "تنظیمات",
    },
    Settings_Building: {
        en: "Building a store",
        fa: "ساخت فروشگاه",
    },
    Settings_reports: {
        en: "reports",
        fa: "گزارشات",
    },
    Settings_Notifications: {
        en: "Notifications",
        fa: "اعلان ها",
    },
    Settings_Field: {
        en: "Field research",
        fa: "تحقیقات میدانی",
    },
    Settings_Introduction: {
        en: "Introduction to customers",
        fa: "معرفی به مشتریان",
    },
    Settings_help: {
        en: "help",
        fa: "راهنما",
    },
    Settings_Support: {
        en: "Support",
        fa: "پشتیبانی",
    },
    Settings_Language: {
        en: "Language",
        fa: "زبان",
    },
    Settings_Sign: {
        en: "Sign out of the account",
        fa: "خروج از حساب",
    },
    reports_Daily: {
        en: "Daily Report",
        fa: "گزارش روزانه",
    },
    reports_New: {
        en: "New order",
        fa: "سفارش جدید",
    },
    reports_monthly: {
        en: "monthly report",
        fa: "گزارش ماهانه",
    },
    reports_annual: {
        en: "annual report",
        fa: "گزارش سالانه",
    },
    Field_research_Sales: {
        en: "Sales status",
        fa: "وضعیت فروش",
    },
    Field_research_competing: {
        en: "competing companies",
        fa: "شرکتهای رقیب",
    },
    Edit_store: {
        en: "Edit store",
        fa: "ویرایش فروشگاه",
    },
    Edit_store_Record: {
        en: "Record changes",
        fa: "ثبت تغییرات",
    },
    Map: {
        en: "Map",
        fa: "نقشه",
    },
    Map_next: {
        en: "next one",
        fa: "بعدی",
    },
    Map_Previous: {
        en: "Previous",
        fa: "قبلی",
    },
    Map_Address: {
        en: "Address",
        fa: "آدرس",
    },
    profile: {
        en: "profile",
        fa: "پروفایل",
    },
    profile_Minimum: {
        en: "Minimum sales ceiling",
        fa: "حداقل سقف فروش",
    },
    profile_visit: {
        en: "visit State",
        fa: "استان ویزیت",
    },
    profile_City: {
        en: "City visit",
        fa: "شهر ویزیت",
    },
    profile_Area: {
        en: "Area covered",
        fa: "منطقه تحت پوشش",
    },
    profile_Sales: {
        en: "Sales manager",
        fa: "سرپرست فروش",
    },
    profile_Covered: {
        en: "Covered route",
        fa: "مسیر تحت پوشش",
    },
    profile_Type: {
        en: "Type of visit",
        fa: "نوع ویزیت",
    },
    profile_warehouse: {
        en: "warehouse address",
        fa: "آدرس انبار",
    },
    profile_Start: {
        en: "Start of visit",
        fa: "شروع ویزیت",
    },
    profile_end: {
        en: "end of visit",
        fa: "پایان ویزیت",
    },
    Exit: {
        en: "Exit",
        fa: "خروج",
    },
    Exit_Would: {
        en: "Would you like to exit the program?",
        fa: "آیا مایل به خروج از برنامه هستید؟",
    },
    Exit_stay: {
        en: "I will stay",
        fa: "می مانم",
    },
    work_start_prompt_title: {
        en: "Register work start time",
        fa: "ثبت ساعت شروع کاری",
    },
    work_start_prompt_question: {
        en: "Would you like to register your work start time?",
        fa: "آیا مایل هستید ساعت شروع کاری خود را ثبت کنید؟",
    },
    work_start_prompt_yes: {
        en: "Yes",
        fa: "بله",
    },
    work_start_prompt_no: {
        en: "No",
        fa: "خیر",
    },
    the_payment_Cash: {
        en: "Cash payment",
        fa: "پرداخت نقدی",
    },
    the_payment_Total: {
        en: "Total : ",
        fa: "جمع : ",
    },
    the_payment_pos: {
        en: "pos payment",
        fa: "پرداخت کارتخوان",
    },
    the_payment_check: {
        en: "Czech payment",
        fa: "پرداخت چک",
    },
    the_payment_picture: {
        en: "The picture arrived",
        fa: "تصویر رسید",
    },
    toast_error: {
        en: "Please fill in all fields",
        fa: "لطفا تمام فیلدها را پر کنید",
    },
    toast_error2: {
        en: "The number entered is greater than the number of items",
        fa: "تعداد وارد شده بیشتر از تعداد کالاست",
    },
    toast_error3: {
        en: "The comment was successfully submitted",
        fa: "نظر با موفقیت ثبت شد",
    },
    toast_error4: {
        en: "Description successfully registered",
        fa: "توضیحات با موفقیت ثبت شد",
    },
    toast_error5: {
        en: "copied",
        fa: "کپی شد",
    },
    toast_error7: {
        en: "Canceled successfully",
        fa: "با موفقیت لغو شد",
    },
    login01: {
        en: "user name",
        fa: "نام کاربری",
    },
    login02: {
        en: "password",
        fa: "رمز عبور",
    },
    toast_error001: {
        en: "Calendar",
        fa: "تقویم",
    },
    toast_error002: {
        en: "Store",
        fa: "فروشگاه",
    },
    toast_error003: {
        en: "search",
        fa: "جستجو کنید",
    },
    toast_error004: {
        en: "Postal address",
        fa: "آدرس پستی",
    },
    toast_error005: {
        en: "You have been disconnected",
        fa: "ارتباط شما قطع شد",
    },
    toast_error006: {
        en: "Enter the phone with the city code",
        fa: "شماره تلفن را با کد شهر وارد کنید",
    },
    toast_error007: {
        en: "Enter the complete mobile phone",
        fa: "شماره موبایل را کامل وارد کنید",
    },
    toast_error008: {
        en: "Record the location of the store on the map",
        fa: "لطفاً موقعیت فروشگاه را روی نقشه ثبت کنید",
    },
    toast_error009: {
        en: "Enter the province, city, municipality and route.",
        fa: "استان شهر و منطقه شهرداری و مسیر را وارد کنید.",
    },
    toast_error010: {
        en: "Select the class",
        fa: "صنف را انتخاب کنید",
    },
    toast_error011: {
        en: "Enter the address",
        fa: "آدرس را وارد کنید",
    },
    toast_error012: {
        en: "Enter the name of the store",
        fa: "نام فروشگاه را وارد کنید",
    },
    toast_error013: {
        en: "Enter last name",
        fa: "نام خانوادگی را وارد کنید",
    },
    toast_error014: {
        en: "enter name",
        fa: "نام را وارد کنید",
    },
    toast_error015: {
        en: "No payments have been registered",
        fa: "هیچ پرداختی ثبت نشده است",
    },
    toast_error016: {
        en: "No cancellation orders have been registered",
        fa: "هیچ سفارش کنسلی ثبت نشده است",
    },
    toast_error017: {
        en: "No confirmed orders have been placed",
        fa: "هیچ سفارش تایید شده ای ثبت نشده است",
    },
    toast_error018: {
        en: "No returns have been registered",
        fa: "هیچ مرجوعی و برگشتی ثبت نشده است",
    },
    toast_error019: {
        en: "There are no pending orders",
        fa: "هیچ سفارش در دست اقدامی ثبت نشده است",
    },
    toast_error020: {
        en: "No new orders have been placed",
        fa: "هیچ سفارش جدیدی ثبت نشده است",
    },
    toast_error021: {
        en: "There are no pending orders",
        fa: "هیچ سفارش در دست اقدامی ثبت نشده است",
    },
    toast_error022: {
        en: "No stores have been registered",
        fa: "هیچ فروشگاهی ثبت نشده است",
    },
    toast_error023: {
        en: "Product not registered",
        fa: "کالایی ثبت نشده است",
    },
    toast_error024: {
        en: "All stores have been visited",
        fa: "همه فروشگاه ها ویزیت شده اند.",
    },
    research_excellent: {
        en: "excellent",
        fa: "عالی",
    },
    research_good: {
        en: "good",
        fa: "خوب",
    },
    research_medium: {
        en: "medium",
        fa: "متوسط",
    },
    research_weak: {
        en: "weak",
        fa: "ضعیف",
    },
};

export const translation = withLanguageFallbacks(baseTranslation);
